module.exports = __webpack_public_path__ + "img/i_frontier-mission_on.a41a321.png";